export default [
    { name: 'Tag', value: 'Day' },
    //{ name: 'Woche', value: 'Week' },
    { name: 'Monat', value: 'Month' },
    { name: 'Jahr', value: 'Year' },
    { name: 'Spanne', value: 'Range' }
];
